import { styled, alpha } from "@mui/material/styles";
import Menu from "@mui/material/Menu";
import { MenuProps } from "@mui/material/Menu";
import { tokens } from "../../theme";

const StyledMenu = styled((props: MenuProps) => {
  return <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />;
})(({ theme }) => {
  const colors = tokens(theme.palette.mode);
  const isDark = theme.palette.mode === "dark";

  return {
    "& .MuiPaper-root": {
      borderRadius: 6,
      marginTop: theme.spacing(0.5),
      minWidth: 180,
      backgroundColor: isDark ? "#212534" : "#ffffff",
      color: colors.grey[100],
      fontWeight: "bold",
      "& .MuiMenuItem-root": {
        "& .MuiSvgIcon-root": {
          fontSize: 18,
          color: colors.grey[100],
          marginRight: theme.spacing(1.5),
        },
        "&:active": {
          backgroundColor: alpha(
            colors.success[300],
            theme.palette.action.selectedOpacity
          ),
        },
      },
    },
  };
});

export default StyledMenu;